import { Frequency } from '@classy/campaign-page-blocks'
import { translate } from './translate'

export const getDonationFrequencies = (): { [key in Frequency]: string } => ({
  'bi-weekly': translate('donationFrequencies.bi-weekly', 'Bi-Weekly'),
  daily: translate('donationFrequencies.daily', 'Daily'),
  monthly: translate('donationFrequencies.monthly', 'Monthly'),
  'one-time': translate('donationFrequencies.one-time', 'One-Time'),
  quarterly: translate('donationFrequencies.quarterly', 'Quarterly'),
  'semi-annually': translate('donationFrequencies.semi-annually', 'Semi-Annually'),
  weekly: translate('donationFrequencies.weekly', 'Weekly'),
  yearly: translate('donationFrequencies.yearly', 'Yearly'),
})

// Get the frequency string from 'frequency' query param
export const getFrequencyString = (frequency: Frequency | undefined): string => {
  const frequencies = getDonationFrequencies()

  return frequencies[frequency ?? 'one-time']
}
